// 菜单，侧边栏
import dashboard from './modules/dashboard';
import auth from './modules/auth';
import system from './modules/system';
import agent from './modules/agent';
import house from './modules/house';
import report from './modules/report';

// 系统
import log from './modules/log';

export default [
    dashboard,
    auth,
    system,
    house,
    agent,
    log,
    report
];
